import React, { useState, useEffect, useContext } from "react";
import { LanguageContext } from "./LanguageContext";

// Wire profiles data - expanded version
const wireProfiles = [
  {
    id: "ka1",
    nm: "Kanthal A1 / APM",
    rstv: 1.45,
    hc: 0.46,
    dens: 7.1,
    tfr: [
      [20, 1],
      [100, 1.0001],
      [400, 1.001],
      [500, 1.01],
      [600, 1.02],
      [700, 1.02],
      [800, 1.03],
      [900, 1.04],
      [1000, 1.04],
      [1200, 1.04],
      [1300, 1.04],
      [1400, 1.05],
    ],
  },
  {
    id: "ni200",
    nm: "Nickel Ni200 (TFR curve)",
    rstv: 0.096,
    hc: 0.456,
    dens: 8.89,
    tcr: 0.006,
    tfr: [
      [-73.33, 0.620729625],
      [-17.77, 0.827668249],
      [20, 1],
      [21.11, 1.000002145],
      [93.33, 1.310323834],
      [204.44, 1.948226332],
      [315.55, 2.827586174],
      [426.66, 3.517266511],
    ],
  },
  {
    id: "ka",
    nm: "Kanthal A / AE / AF",
    rstv: 1.39,
    hc: 0.4625,
    dens: 7.15,
    tfr: [
      [20, 1],
      [100, 1.001],
      [200, 1.01],
      [300, 1.015],
      [400, 1.02],
      [500, 1.03],
      [600, 1.04],
      [700, 1.045],
      [800, 1.05],
      [900, 1.055],
      [1e3, 1.06],
      [1300, 1.065],
    ],
  },
  {
    id: "kd",
    nm: "Kanthal D",
    rstv: 1.35,
    hc: 0.465,
    dens: 7.25,
    tfr: [
      [20, 1],
      [100, 1.001],
      [200, 1.01],
      [300, 1.015],
      [400, 1.02],
      [500, 1.03],
      [600, 1.04],
      [700, 1.05],
      [800, 1.06],
      [900, 1.07],
      [1100, 1.075],
      [1200, 1.08],
      [1300, 1.085],
    ],
  },
  {
    id: "n20",
    nm: "Nichrome N20",
    rstv: 0.95,
    hc: 0.447,
    dens: 8.7,
  },
  {
    id: "n40",
    nm: "Nichrome N40",
    rstv: 1.04,
    hc: 0.447,
    dens: 8.6,
  },
  {
    id: "n60",
    nm: "Nichrome N60 (C)",
    rstv: 1.11,
    hc: 0.447,
    dens: 8.5,
    tcr: 4e-4,
    tfr: [
      [20, 1],
      [93, 1.017],
      [204, 1.035],
      [315, 1.052],
      [427, 1.069],
      [538, 1.086],
      [649, 1.092],
      [760, 1.098],
      [871, 1.102],
      [985, 1.105],
    ],
  },
  {
    id: "n70",
    nm: "Nichrome N70 (B)",
    rstv: 1.18,
    hc: 0.447,
    dens: 8.4,
  },
  {
    id: "n80",
    nm: "Nichrome N80 (A)",
    rstv: 1.09,
    hc: 0.447,
    dens: 8.31,
    tfr: [
      [20, 1],
      [93, 1.008],
      [204, 1.02],
      [315, 1.033],
      [427, 1.048],
      [538, 1.063],
    ],
  },
  {
    id: "n90",
    nm: "Nichrome N90",
    rstv: 0.75,
    hc: 0.44,
    dens: 8.7,
  },
  {
    id: "ss304",
    nm: "SS 304",
    rstv: 0.713,
    hc: 0.5,
    dens: 8,
    tfr: [
      [-100, 0.8412],
      [20, 1],
      [100, 1.0909],
      [150, 1.1426],
      [200, 1.1917],
      [250, 1.2388],
      [300, 1.2844],
      [500, 1.4445],
    ],
  },
  {
    id: "ss316",
    nm: "SS 316",
    rstv: 0.771,
    hc: 0.5,
    dens: 8,
    tfr: [
      [-100, 0.8646],
      [20, 1],
      [100, 1.0795],
      [150, 1.1258],
      [200, 1.1678],
      [250, 1.2075],
      [300, 1.2463],
      [500, 1.3844],
    ],
  },
  {
    id: "ss316l",
    nm: "SS 316L / Elite",
    rstv: 0.75,
    hc: 0.5,
    dens: 8,
    tfr: [
      [-183, 0.7588],
      [-173, 0.7717],
      [-123, 0.8366],
      [-73, 0.8962],
      [-23, 0.9546],
      [0, 0.978],
      [20, 1],
      [100, 1.08],
      [105, 1.084],
      [110, 1.089],
      [115, 1.094],
      [120, 1.099],
      [125, 1.103],
      [130, 1.108],
      [135, 1.112],
      [140, 1.117],
      [145, 1.121],
      [150, 1.126],
      [155, 1.13],
      [160, 1.134],
      [165, 1.139],
      [170, 1.143],
      [175, 1.147],
      [180, 1.151],
      [185, 1.156],
      [190, 1.16],
      [195, 1.164],
      [200, 1.168],
      [205, 1.172],
      [210, 1.176],
      [215, 1.18],
      [220, 1.184],
      [225, 1.188],
      [230, 1.192],
      [235, 1.196],
      [240, 1.2],
      [245, 1.204],
      [250, 1.207],
      [255, 1.211],
      [260, 1.215],
      [265, 1.219],
      [270, 1.223],
      [275, 1.227],
      [280, 1.231],
      [285, 1.235],
      [290, 1.239],
      [295, 1.242],
      [300, 1.246],
      [327, 1.2672],
      [427, 1.3372],
      [527, 1.4008],
      [627, 1.454],
      [727, 1.5006],
    ],
  },
  {
    id: "ss317l",
    nm: "SS 317L / Haywire",
    rstv: 0.81,
    hc: 0.5,
    dens: 7.9,
    tcr: 94e-5,
  },
  {
    id: "ss321",
    nm: "SS 321",
    rstv: 0.746,
    hc: 0.5,
    dens: 8.09,
    tfr: [
      [-272, 0.702412869],
      [-269, 0.702412869],
      [-263, 0.702412869],
      [-253, 0.701072386],
      [-243, 0.699731903],
      [-233, 0.701072386],
      [-223, 0.705093834],
      [-213, 0.711796247],
      [-203, 0.719839142],
      [-193, 0.731903485],
      [-183, 0.745308311],
      [-173, 0.760053619],
      [-123, 0.827077748],
      [-73, 0.892761394],
      [-23, 0.95308311],
      [0, 0.978552279],
      [20, 1],
      [27, 1.008042895],
      [77, 1.058981233],
      [127, 1.108579088],
      [227, 1.197050938],
      [327, 1.278820375],
      [427, 1.352546917],
      [527, 1.420911528],
      [627, 1.478552279],
      [727, 1.526809651],
      [827, 1.569705094],
      [927, 1.608579088],
      [1027, 1.644772118],
      [1127, 1.679624665],
      [1227, 1.713136729],
      [1327, 1.742627346],
      [1399, 1.764075067],
    ],
  },
  {
    id: "ss430",
    nm: "SS 430",
    rstv: 0.6,
    hc: 0.46,
    dens: 7.74,
    tcr: 0.00138,
  },
  {
    id: "au",
    nm: "Gold",
    rstv: 0.035,
    hc: 0.129,
    dens: 19.32,
    tcr: 0.0034,
  },
  {
    id: "ag",
    nm: "Silver",
    rstv: 0.0159,
    hc: 0.233,
    dens: 10.49,
    tcr: 0.0038,
  },
  {
    id: "cu",
    nm: "Copper",
    rstv: 0.0168,
    hc: 0.385,
    dens: 8.96,
    tcr: 0.003862,
  },
  {
    id: "ti1",
    nm: "Titanium 1",
    rstv: 0.47,
    hc: 0.523,
    dens: 4.43,
    tcr: 0.0035,
    tfr: [
      [20, 1],
      [24, 1.022177419],
      [37, 1.066532258],
      [53, 1.120967742],
      [66, 1.169354839],
      [78, 1.213709677],
      [94, 1.272177419],
      [106, 1.3125],
      [120, 1.366935484],
      [134, 1.41733871],
      [147, 1.463709677],
      [159, 1.510080645],
      [176, 1.572580645],
      [189, 1.622983871],
      [221, 1.739919355],
      [233, 1.782258065],
      [247, 1.836693548],
      [258, 1.872983871],
      [270, 1.915322581],
      [287, 1.97983871],
      [301, 2.028225806],
      [323, 2.106854839],
      [339, 2.163306452],
      [353, 2.20766129],
      [364, 2.245967742],
      [374, 2.278225806],
      [392, 2.336693548],
      [404, 2.379032258],
      [419, 2.425403226],
      [431, 2.465725806],
      [445, 2.510080645],
      [460, 2.556451613],
      [479, 2.614919355],
      [497, 2.665322581],
      [513, 2.709677419],
      [541, 2.788306452],
      [557, 2.828629032],
      [574, 2.870967742],
      [594, 2.921370968],
      [609, 2.959677419],
      [630, 3.006048387],
      [646, 3.04233871],
      [669, 3.090725806],
      [683, 3.116935484],
      [702, 3.153225806],
      [720, 3.189516129],
      [739, 3.219758065],
      [753, 3.243951613],
      [770, 3.27016129],
      [794, 3.306451613],
      [812, 3.330645161],
      [830, 3.352822581],
      [843, 3.370967742],
    ],
  },
  {
    id: "ti2",
    nm: "Titanium 2 (R50400)",
    rstv: 0.56,
    hc: 0.54,
    dens: 4.51,
    tfr: [
      [20, 1],
      [27, 1.027237354],
      [44, 1.091439689],
      [61, 1.145914397],
      [76, 1.210116732],
      [95, 1.262645914],
      [109, 1.317120623],
      [128, 1.383268482],
      [146, 1.443579767],
      [163, 1.505836576],
      [181, 1.56614786],
      [199, 1.630350195],
      [217, 1.694552529],
      [233, 1.750972763],
      [247, 1.80155642],
      [266, 1.86770428],
      [287, 1.939688716],
      [311, 2.027237354],
      [328, 2.087548638],
      [343, 2.13618677],
      [360, 2.190661479],
      [387, 2.274319066],
      [413, 2.357976654],
      [430, 2.406614786],
      [456, 2.492217899],
      [475, 2.542801556],
      [495, 2.605058366],
      [521, 2.673151751],
      [535, 2.710116732],
      [555, 2.760700389],
      [569, 2.793774319],
      [591, 2.842412451],
      [606, 2.879377432],
      [628, 2.929961089],
      [641, 2.957198444],
      [658, 2.990272374],
      [672, 3.019455253],
      [693, 3.058365759],
      [719, 3.10311284],
      [743, 3.142023346],
      [755, 3.175097276],
      [772, 3.196498054],
      [800, 3.219844358],
      [836, 3.26459144],
    ],
  },
  {
    id: "tie",
    nm: "Titanium ready (e-SG)",
    rstv: 0.85,
    hc: 0.56,
    dens: 4.75,
  },
  {
    id: "w",
    nm: "Tungsten",
    rstv: 0.056,
    dens: 19.25,
    hc: 0.134,
    tcr: 0.0045,
  },
  {
    id: "nio",
    nm: "Niobium alloy",
    rstv: 1.46809443507,
    hc: 0.45,
    dens: 7.5,
  },
  {
    id: "ni200lin",
    nm: "Nickel Ni200 (linear TCR)",
    rstv: 0.096,
    hc: 0.456,
    dens: 8.89,
    tcr: 0.006,
  },
  {
    id: "nife30",
    nm: "NiFe30 (Resistherm - TFR)",
    rstv: 0.33,
    hc: 0.42,
    dens: 8.5,
    tcr: 0.0032,
    tfr: [
      [20, 1],
      [100, 41 / 33],
      [200, 52 / 33],
      [300, 64 / 33],
      [400, 76 / 33],
      [500, 89 / 33],
    ],
  },
  {
    id: "dicodes",
    nm: "NiFe30 (Resistherm - TCR)",
    rstv: 0.33,
    hc: 0.42,
    dens: 8.5,
    tcr: 0.0032,
  },
  {
    id: "reactor",
    nm: "NiFe (Reactor Wire)",
    rstv: 0.4334,
    hc: 0.42,
    dens: 8.5,
    tcr: 0.004,
  },
  {
    id: "nife30stealth",
    nm: "NiFe30 (StealthVape)",
    rstv: 0.21,
    hc: 0.42,
    dens: 8.5,
    tcr: 0.005,
  },
  {
    id: "invar36",
    nm: "Invar 36 / Nilo 36 / Pernifer 36",
    rstv: 0.82,
    hc: 0.515,
    dens: 8.055,
    tcr: 0.001,
    tfr: [
      [20, 1],
      [100, 1.075],
      [200, 1.2125],
      [300, 1.3125],
      [400, 1.3875],
      [500, 1.4625],
      [600, 1.5125],
    ],
  },
  {
    id: "nidh",
    nm: "Nickel DH",
    rstv: 0.09,
    hc: 0.48,
    dens: 8.9,
    tfr: [
      [-100, 0.6],
      [20, 1],
      [100, 1.4],
      [150, 1.6941],
      [200, 2.08],
      [250, 2.5092],
      [300, 2.97],
      [500, 4.23],
    ],
  },
  {
    id: "nft70",
    nm: "Nifethal 70 (Alloy120)",
    rstv: 0.2,
    hc: 0.52,
    dens: 8.45,
    tfr: [
      [-100, 0.576],
      [20, 1],
      [100, 1.42],
      [150, 1.68],
      [200, 1.91],
      [250, 2.19],
      [300, 2.47],
      [500, 3.66],
    ],
  },
  {
    id: "nft52",
    nm: "Nifethal 52 (Alloy52)",
    rstv: 0.37,
    hc: 0.5,
    dens: 8.2,
    tfr: [
      [-100, 0.664],
      [20, 1],
      [100, 1.33],
      [150, 1.53],
      [200, 1.73],
      [250, 1.93],
      [300, 2.13],
      [500, 2.77],
    ],
  },
  {
    id: "zr",
    nm: "Zirconium (pure)",
    rstv: 0.433,
    hc: 0.278,
    dens: 6.52,
    tcr: 0.0044,
  },
];

// Expanded coil setups
const coilSetups = [
  { value: 0, label: "Single Coil", numberofcoils: 1 },
  { value: 1, label: "Dual Coil", numberofcoils: 2 },
  { value: 2, label: "Triple Coil", numberofcoils: 3 },
  { value: 3, label: "Quad Coil", numberofcoils: 4 },
  { value: 4, label: "Penta Coil", numberofcoils: 5 },
  { value: 5, label: "Hexa Coil", numberofcoils: 6 },
  { value: 6, label: "Hepta Coil", numberofcoils: 7 },
  { value: 7, label: "Octa Coil", numberofcoils: 8 },
];

const wireGauges = {
  awg: [
    38, 37, 36, 35, 34, 33, 32, 31, 30, 29, 28, 27, 26, 25, 24, 23, 22, 21, 20,
    19, 18,
  ],
  diameter: [
    0.101, 0.113, 0.127, 0.143, 0.1603, 0.1798, 0.2019, 0.2268, 0.254, 0.287,
    0.32, 0.3607, 0.4039, 0.4547, 0.5105, 0.574, 0.6452, 0.723, 0.812, 0.912,
    1.024,
  ],
};

// Expanded wire shapes
const wireShapes = [
  { value: 0, label: "Round - Single", profile: "round", numberofstrands: 1 },
  { value: 1, label: "Round - Parallel", profile: "round", numberofstrands: 2 },
  { value: 2, label: "Round - Triple", profile: "round", numberofstrands: 3 },
  { value: 3, label: "Round - Quad", profile: "round", numberofstrands: 4 },
  { value: 4, label: "Ribbon - Flat", profile: "flat", numberofstrands: 1 },
];

const wireTypeResistivity = {
  ka1: 1.45,
  n80: 1.09,
  ni200: 0.096,
  ss316l: 0.771,
  ti1: 0.47,
};

const defaultValues = {
  wiretype: "ka1",
  wireshape: 0,
  wirediameterawg: 30,
  wirediametermm: 0.254,
  coilsetup: 0,
  targetresistance: 1.8,
  numberofwraps: 6,
  coildiameter: 1.3,
  coillegslength: 5,
  calculationMode: "target",
  twistpitch: 0, // Nuovo parametro per il twist
  temperature: 20, // Per calcoli TFR
};

const CoilCalculator = ({ getStyles, theme }) => {
    const { t } = useContext(LanguageContext);

  const [inputs, setInputs] = useState(defaultValues);
  const [results, setResults] = useState(null);
  const [showAdvanced, setShowAdvanced] = useState(false);

  // Utility functions
  const awg2mm = (x) => {
    return in2mm(awg2in(x));
  };

  const [ribbonDimensions, setRibbonDimensions] = useState({
    thickness: 0.1, // mm
    width: 0.8, // mm
  });

  const [powerCalcs, setPowerCalcs] = useState({
    voltage: 4.2,
    current: 0,
    power: 0,
    surfaceArea: 0,
  });

  const awg2in = (x) => {
    return 0.005 * Math.pow(92, (36 - x) / 39);
  };

  const in2mm = (x) => {
    return 25.4 * x;
  };

  const findWireProfile = (wireType) => {
    return wireProfiles.find((w) => w.id === wireType);
  };

  const findTFRMultiplier = (wireType, temperature) => {
    const wire = findWireProfile(wireType);
    if (!wire?.tfr) return 1;

    const tfr = wire.tfr;
    // Find the closest temperature points
    let low = tfr[0];
    let high = tfr[tfr.length - 1];

    for (let i = 0; i < tfr.length - 1; i++) {
      if (tfr[i][0] <= temperature && tfr[i + 1][0] >= temperature) {
        low = tfr[i];
        high = tfr[i + 1];
        break;
      }
    }

    // Linear interpolation
    const ratio = (temperature - low[0]) / (high[0] - low[0]);
    return low[1] + (high[1] - low[1]) * ratio;
  };

  const calculateTwistedArea = (wireDiameter, numberOfStrands) => {
    if (!inputs.twistpitch || inputs.twistpitch === 0) {
      return Math.PI * Math.pow(wireDiameter / 2, 2) * numberOfStrands;
    }

    const twistLead = inputs.twistpitch * numberOfStrands;
    const circumference = wireDiameter * Math.PI;
    const twistedLength = Math.sqrt(
      Math.pow(circumference, 2) + Math.pow(twistLead, 2)
    );
    const twistFactor = twistedLength / twistLead;

    return (
      Math.PI * Math.pow(wireDiameter / 2, 2) * numberOfStrands * twistFactor
    );
  };

  const calculateInnerCoilCircumference = () => {
    const wireShape = wireShapes.find((s) => s.value === inputs.wireshape);

    if (wireShape?.profile === "flat") {
      return (inputs.coildiameter + ribbonDimensions.thickness * 2) * Math.PI;
    } else {
      return (
        (inputs.coildiameter + awg2mm(inputs.wirediameterawg) * 2) * Math.PI
      );
    }
  };

  const findXArea = () => {
    const wireShape = wireShapes.find((s) => s.value === inputs.wireshape);

    if (wireShape?.profile === "flat") {
      return ribbonDimensions.thickness * ribbonDimensions.width;
    }

    const wireDiameter = awg2mm(inputs.wirediameterawg);
    const numberOfStrands = wireShape?.numberofstrands || 1;
    return Math.PI * Math.pow(wireDiameter / 2, 2) * numberOfStrands;
  };

  const getReturnRValue = () => {
    const wire = findWireProfile(inputs.wiretype);
    if (!wire) return 0;

    const wireShape = wireShapes.find((s) => s.value === inputs.wireshape);
    if (wireShape?.profile === "flat") {
      // Logica specifica per il ribbon
      return (
        wire.rstv / 1000 / (ribbonDimensions.thickness * ribbonDimensions.width)
      );
    } else {
      // Logica esistente per i fili rotondi
      const tfrMultiplier = findTFRMultiplier(
        inputs.wiretype,
        inputs.temperature
      );
      return (wire.rstv * tfrMultiplier) / 1000 / findXArea();
    }
  };

  const calculateHeatCapacity = (wireLength) => {
    const wire = findWireProfile(inputs.wiretype);
    if (!wire) return 0;

    const volume = findXArea() * wireLength;
    const mass = volume * wire.dens;
    return wire.hc * mass;
  };

  const handleCalculate = () => {
    if (inputs.calculationMode === "target") {
      calculateForTargetResistance();
    } else {
      calculateForGivenWraps();
    }
  };

  const calculatePowerStats = (resistance, wireLength) => {
    const current = powerCalcs.voltage / resistance;
    const power = powerCalcs.voltage * current;
    const surfaceArea =
      wireShapes.find((s) => s.value === inputs.wireshape)?.profile === "flat"
        ? (wireLength - inputs.coillegslength) *
          (ribbonDimensions.thickness * 2 + ribbonDimensions.width * 2)
        : (wireLength - inputs.coillegslength) *
          Math.PI *
          awg2mm(inputs.wirediameterawg);

    setPowerCalcs({
      ...powerCalcs,
      current,
      power,
      surfaceArea,
    });
  };

  const calculateForTargetResistance = () => {
    const coilSetup = coilSetups.find((s) => s.value === inputs.coilsetup);
    const wireShape = wireShapes.find((s) => s.value === inputs.wireshape);
    const numberOfCoils = coilSetup?.numberofcoils || 1;
    const numberOfStrands = wireShape?.numberofstrands || 1;

    // Calcolo della lunghezza del filo
    const wireLength =
      (inputs.targetresistance / getReturnRValue()) *
      numberOfStrands *
      numberOfCoils;

    const innerCoilCircumference = calculateInnerCoilCircumference();

    // Calcolo effettivo dei wrap per il ribbon
    const numberWraps =
      (wireLength - inputs.coillegslength) / innerCoilCircumference;
    const fullWraps = Math.round(numberWraps);

    // Calcolo della resistenza effettiva
    const actualResistance =
      (getReturnRValue() *
        (fullWraps * innerCoilCircumference + inputs.coillegslength)) /
      numberOfStrands /
      numberOfCoils;

    const legLoss = (inputs.coillegslength / wireLength) * 100;
    const heatCapacity = calculateHeatCapacity(wireLength);

    calculatePowerStats(actualResistance, wireLength);

    setResults({
      mode: "target",
      wireLength: wireLength.toFixed(2),
      numberWraps: numberWraps.toFixed(2),
      fullWraps,
      halfWraps: `${Math.round(numberWraps) + 1}/${Math.round(numberWraps)}`,
      actualResistance: actualResistance.toFixed(2),
      legLoss: legLoss.toFixed(1),
      heatCapacity: heatCapacity.toFixed(2),
      temperature: inputs.temperature,
      tfrMultiplier: findTFRMultiplier(
        inputs.wiretype,
        inputs.temperature
      ).toFixed(3),
    });
  };

  const calculateForGivenWraps = () => {
    const coilSetup = coilSetups.find((s) => s.value === inputs.coilsetup);
    const wireShape = wireShapes.find((s) => s.value === inputs.wireshape);
    const numberOfCoils = coilSetup?.numberofcoils || 1;
    const numberOfStrands = wireShape?.numberofstrands || 1;

    const innerCoilCircumference = calculateInnerCoilCircumference();

    const wireLength =
      inputs.numberofwraps * innerCoilCircumference + inputs.coillegslength;

    const resistance =
      (getReturnRValue() * wireLength) / numberOfStrands / numberOfCoils;

    const legLoss = (inputs.coillegslength / wireLength) * 100;
    const heatCapacity = calculateHeatCapacity(wireLength);

    // Calcola le statistiche di potenza passando wireLength
    calculatePowerStats(resistance, wireLength);

    setResults({
      mode: "result",
      wireLength: wireLength.toFixed(2),
      actualResistance: resistance.toFixed(2),
      numberWraps: inputs.numberofwraps,
      legLoss: legLoss.toFixed(1),
      heatCapacity: heatCapacity.toFixed(2),
      temperature: inputs.temperature,
      tfrMultiplier: findTFRMultiplier(
        inputs.wiretype,
        inputs.temperature
      ).toFixed(3),
    });
  };

  useEffect(() => {
    const mm = awg2mm(inputs.wirediameterawg);
    if (mm !== inputs.wirediametermm) {
      setInputs((prev) => ({ ...prev, wirediametermm: mm }));
    }
  }, [inputs.wirediameterawg]);

  return (
    <div style={getStyles(theme).content}>
      <div style={getStyles(theme).section}>
        <h2 style={getStyles(theme).sectionTitle}>{t("coilCalculator")}</h2>

        {/* Mode Switch */}
        <div style={{ ...getStyles(theme).inputGroup, marginBottom: "20px" }}>
          <label style={getStyles(theme).label}>
            {inputs.calculationMode === "target"
              ? t("targetResistanceMode")
              : t("calculateResistanceMode")}
          </label>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <div
              onClick={() =>
                setInputs((prev) => ({
                  ...prev,
                  calculationMode:
                    inputs.calculationMode === "target" ? "result" : "target",
                }))
              }
              style={{
                position: "relative",
                width: "60px",
                height: "24px",
                backgroundColor:
                  inputs.calculationMode === "result"
                    ? "var(--primary)"
                    : "#ccc",
                borderRadius: "34px",
                cursor: "pointer",
                transition: "background-color 0.3s",
              }}
            >
              <span
                style={{
                  position: "absolute",
                  height: "20px",
                  width: "20px",
                  left: inputs.calculationMode === "result" ? "36px" : "2px",
                  bottom: "2px",
                  backgroundColor: "white",
                  borderRadius: "50%",
                  transition: "left 0.3s",
                }}
              />
            </div>
          </div>
        </div>

        {/* Input Grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "20px",
            marginBottom: "24px",
          }}
        >
          {/* Wire Type Selection */}
          <div style={getStyles(theme).inputGroup}>
            <label style={getStyles(theme).label}>{t("wireType")}</label>
            <select
              style={getStyles(theme).select}
              value={inputs.wiretype}
              onChange={(e) =>
                setInputs((prev) => ({ ...prev, wiretype: e.target.value }))
              }
            >
              {wireProfiles.map((wire) => (
                <option key={wire.id} value={wire.id}>
                  {wire.nm}
                </option>
              ))}
            </select>
          </div>

          {/* Wire Configuration */}
          <div style={getStyles(theme).inputGroup}>
            <label style={getStyles(theme).label}>
              {t("wireConfiguration")}
            </label>
            <select
              style={getStyles(theme).select}
              value={inputs.wireshape}
              onChange={(e) =>
                setInputs((prev) => ({
                  ...prev,
                  wireshape: Number(e.target.value),
                }))
              }
            >
              {wireShapes.map((shape) => (
                <option key={shape.value} value={shape.value}>
                  {shape.label}
                </option>
              ))}
            </select>
          </div>

          {/* Coil Setup */}
          <div style={getStyles(theme).inputGroup}>
            <label style={getStyles(theme).label}>{t("coilSetup")}</label>
            <select
              style={getStyles(theme).select}
              value={inputs.coilsetup}
              onChange={(e) =>
                setInputs((prev) => ({
                  ...prev,
                  coilsetup: Number(e.target.value),
                }))
              }
            >
              {coilSetups.map((setup) => (
                <option key={setup.value} value={setup.value}>
                  {setup.label}
                </option>
              ))}
            </select>
          </div>

          {/* Conditional rendering for Flat or Round wire */}
          {wireShapes.find((s) => s.value === inputs.wireshape)?.profile ===
          "flat" ? (
            <>
              <div style={getStyles(theme).inputGroup}>
                <label style={getStyles(theme).label}>
                  {t("ribbonThickness")}
                </label>
                <div style={getStyles(theme).inputWrapper}>
                  <input
                    style={getStyles(theme).input}
                    type="number"
                    step="0.01"
                    value={ribbonDimensions.thickness}
                    onChange={(e) =>
                      setRibbonDimensions((prev) => ({
                        ...prev,
                        thickness: Number(e.target.value),
                      }))
                    }
                  />
                  <span style={getStyles(theme).unit}>mm</span>
                </div>
              </div>
              <div style={getStyles(theme).inputGroup}>
                <label style={getStyles(theme).label}>{t("ribbonWidth")}</label>
                <div style={getStyles(theme).inputWrapper}>
                  <input
                    style={getStyles(theme).input}
                    type="number"
                    step="0.01"
                    value={ribbonDimensions.width}
                    onChange={(e) =>
                      setRibbonDimensions((prev) => ({
                        ...prev,
                        width: Number(e.target.value),
                      }))
                    }
                  />
                  <span style={getStyles(theme).unit}>mm</span>
                </div>
              </div>
            </>
          ) : (
            <>
              <div style={getStyles(theme).inputGroup}>
                <label style={getStyles(theme).label}>
                  {t("wireDiameterAWG")}
                </label>
                <div style={getStyles(theme).inputWrapper}>
                  <input
                    style={getStyles(theme).input}
                    type="number"
                    value={inputs.wirediameterawg}
                    onChange={(e) => {
                      const value =
                        e.target.value === "" ? 0 : Number(e.target.value);
                      setInputs((prev) => ({
                        ...prev,
                        wirediameterawg: value,
                      }));
                    }}
                  />
                  <span style={getStyles(theme).unit}>AWG</span>
                </div>
              </div>

              <div style={getStyles(theme).inputGroup}>
                <label style={getStyles(theme).label}>
                  {t("wireDiameterMM")}
                </label>
                <div style={getStyles(theme).inputWrapper}>
                  <input
                    style={{
                      ...getStyles(theme).input,
                      backgroundColor: "var(--inputBackground)",
                    }}
                    type="number"
                    value={inputs.wirediametermm.toFixed(3)}
                    readOnly
                  />
                  <span style={getStyles(theme).unit}>mm</span>
                </div>
              </div>
            </>
          )}

          {/* Conditional rendering for target/calculate mode inputs */}
          {inputs.calculationMode === "target" ? (
            <div style={getStyles(theme).inputGroup}>
              <label style={getStyles(theme).label}>
                {t("targetResistance")}
              </label>
              <div style={getStyles(theme).inputWrapper}>
                <input
                  style={getStyles(theme).input}
                  type="number"
                  step="0.1"
                  value={inputs.targetresistance}
                  onChange={(e) => {
                    const value =
                      e.target.value === "" ? 0 : Number(e.target.value);
                    setInputs((prev) => ({ ...prev, targetresistance: value }));
                  }}
                />
                <span style={getStyles(theme).unit}>Ω</span>
              </div>
            </div>
          ) : (
            <div style={getStyles(theme).inputGroup}>
              <label style={getStyles(theme).label}>{t("numberOfWraps")}</label>
              <div style={getStyles(theme).inputWrapper}>
                <input
                  style={getStyles(theme).input}
                  type="number"
                  step="1"
                  value={inputs.numberofwraps}
                  onChange={(e) => {
                    const value =
                      e.target.value === "" ? 0 : Number(e.target.value);
                    setInputs((prev) => ({ ...prev, numberofwraps: value }));
                  }}
                />
              </div>
            </div>
          )}

          {/* Common inputs */}
          <div style={getStyles(theme).inputGroup}>
            <label style={getStyles(theme).label}>
              {t("innerCoilDiameter")}
            </label>
            <div style={getStyles(theme).inputWrapper}>
              <input
                style={getStyles(theme).input}
                type="number"
                step="0.1"
                value={inputs.coildiameter}
                onChange={(e) => {
                  const value =
                    e.target.value === "" ? 0 : Number(e.target.value);
                  setInputs((prev) => ({ ...prev, coildiameter: value }));
                }}
              />
              <span style={getStyles(theme).unit}>mm</span>
            </div>
          </div>

          <div style={getStyles(theme).inputGroup}>
            <label style={getStyles(theme).label}>{t("legLength")}</label>
            <div style={getStyles(theme).inputWrapper}>
              <input
                style={getStyles(theme).input}
                type="number"
                step="0.1"
                value={inputs.coillegslength}
                onChange={(e) => {
                  const value =
                    e.target.value === "" ? 0 : Number(e.target.value);
                  setInputs((prev) => ({ ...prev, coillegslength: value }));
                }}
              />
              <span style={getStyles(theme).unit}>mm</span>
            </div>
          </div>

          {/* Advanced input */}
          {showAdvanced && (
            <div style={getStyles(theme).inputGroup}>
              <label style={getStyles(theme).label}>
                {t("batteryVoltage")}
              </label>
              <div style={getStyles(theme).inputWrapper}>
                <input
                  style={getStyles(theme).input}
                  type="number"
                  step="0.1"
                  value={powerCalcs.voltage}
                  onChange={(e) =>
                    setPowerCalcs((prev) => ({
                      ...prev,
                      voltage: Number(e.target.value),
                    }))
                  }
                />
                <span style={getStyles(theme).unit}>V</span>
              </div>
            </div>
          )}
        </div>

        {/* Buttons */}
        <button
          onClick={() => setShowAdvanced(!showAdvanced)}
          style={{
            ...getStyles(theme).button,
            backgroundColor: "transparent",
            color: "var(--primary)",
            border: "none",
            marginBottom: "20px",
          }}
        >
          {showAdvanced ? t("hideAdvancedInfo") : t("showAdvancedInfo")}
        </button>

        <button style={getStyles(theme).button} onClick={handleCalculate}>
          {inputs.calculationMode === "target"
            ? t("calculateWraps")
            : t("calculateResistance")}
        </button>

        {/* Results Section */}
        {results && (
          <div style={getStyles(theme).resultContainer}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                gap: "16px",
              }}
            >
              {/* Target Mode Results */}
              {results.mode === "target" ? (
                <>
                  <div style={getStyles(theme).resultItem}>
                    <div style={getStyles(theme).resultLabel}>
                      {t("wireLength")}
                    </div>
                    <div style={getStyles(theme).resultValue}>
                      {results.wireLength} mm
                    </div>
                  </div>
                  <div style={getStyles(theme).resultItem}>
                    <div style={getStyles(theme).resultLabel}>
                      {t("calculatedWraps")}
                    </div>
                    <div style={getStyles(theme).resultValue}>
                      {results.numberWraps}
                    </div>
                  </div>
                  <div style={getStyles(theme).resultItem}>
                    <div style={getStyles(theme).resultLabel}>
                      {t("suggestedWraps")}
                    </div>
                    <div style={getStyles(theme).resultValue}>
                      {results.fullWraps}
                    </div>
                  </div>
                  <div style={getStyles(theme).resultItem}>
                    <div style={getStyles(theme).resultLabel}>
                      {t("halfWrapOption")}
                    </div>
                    <div style={getStyles(theme).resultValue}>
                      {results.halfWraps}
                    </div>
                  </div>
                  <div style={getStyles(theme).resultItem}>
                    <div style={getStyles(theme).resultLabel}>
                      {t("actualResistance")}
                    </div>
                    <div style={getStyles(theme).resultValue}>
                      {results.actualResistance} Ω
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div style={getStyles(theme).resultItem}>
                    <div style={getStyles(theme).resultLabel}>
                      {t("wireLength")}
                    </div>
                    <div style={getStyles(theme).resultValue}>
                      {results.wireLength} mm
                    </div>
                  </div>
                  <div style={getStyles(theme).resultItem}>
                    <div style={getStyles(theme).resultLabel}>
                      {t("calculatedResistance")}
                    </div>
                    <div style={getStyles(theme).resultValue}>
                      {results.actualResistance} Ω
                    </div>
                  </div>
                </>
              )}

              {/* Common Results */}
              <div style={getStyles(theme).resultItem}>
                <div style={getStyles(theme).resultLabel}>{t("legLoss")}</div>
                <div style={getStyles(theme).resultValue}>
                  {results.legLoss}%
                </div>
              </div>

              <div style={getStyles(theme).resultItem}>
                <div style={getStyles(theme).resultLabel}>
                  {t("heatCapacity")}
                </div>
                <div style={getStyles(theme).resultValue}>
                  {results.heatCapacity} J/°C
                </div>
              </div>

              {/* Advanced Results */}
              {showAdvanced && (
                <>
                  <div style={getStyles(theme).resultItem}>
                    <div style={getStyles(theme).resultLabel}>
                      {t("temperatureFactor")}
                    </div>
                    <div style={getStyles(theme).resultValue}>
                      {results.tfrMultiplier}x at {results.temperature}°C
                    </div>
                  </div>

                  <div style={getStyles(theme).resultItem}>
                    <div style={getStyles(theme).resultLabel}>
                      {t("surfaceArea")}
                    </div>
                    <div style={getStyles(theme).resultValue}>
                      {powerCalcs.surfaceArea.toFixed(2)} mm²
                    </div>
                  </div>

                  <div style={getStyles(theme).resultItem}>
                    <div style={getStyles(theme).resultLabel}>
                      {t("currentDraw")}
                    </div>
                    <div style={getStyles(theme).resultValue}>
                      {powerCalcs.current.toFixed(2)} A
                    </div>
                  </div>

                  <div style={getStyles(theme).resultItem}>
                    <div style={getStyles(theme).resultLabel}>{t("power")}</div>
                    <div style={getStyles(theme).resultValue}>
                      {powerCalcs.power.toFixed(2)} W
                    </div>
                  </div>
                </>
              )}
            </div>

            {/* Warning Messages */}
            {results.legLoss > 30 && (
              <div
                style={{
                  marginTop: "16px",
                  padding: "16px",
                  backgroundColor: "var(--warning)",
                  color: "var(--warningText)",
                  borderRadius: "6px",
                }}
              >
                {t("warningHighLegLoss")}
              </div>
            )}

            {results.legLoss > 20 && results.legLoss <= 30 && (
              <div
                style={{
                  marginTop: "16px",
                  padding: "16px",
                  backgroundColor: "var(--warning)",
                  color: "var(--warningText)",
                  borderRadius: "6px",
                }}
              >
                {t("warningSignificantLegLoss")}
              </div>
            )}
          </div>
        )}

        {/* Guide Section */}
        <div style={{ marginTop: "40px" }}>
          <h2 style={getStyles(theme).sectionTitle}>{t("quickGuideTitle")}</h2>

          {/* Modes Guide */}
          <div style={{ marginBottom: "24px" }}>
            <h3
              style={{ ...getStyles(theme).subTitle, color: "var(--primary)" }}
            >
              {t("modesExplained")}
            </h3>
            <div
              style={{
                backgroundColor: "var(--sectionBackground)",
                padding: "16px",
                borderRadius: "8px",
                marginTop: "12px",
              }}
            >
              <h4 style={{ ...getStyles(theme).subTitle }}>
                🎯 {t("targetModeTitle")}
              </h4>
              <p style={getStyles(theme).text}>{t("targetModeExplanation")}</p>

              <h4 style={{ ...getStyles(theme).subTitle, marginTop: "16px" }}>
                🔄 {t("calculateModeTitle")}
              </h4>
              <p style={getStyles(theme).text}>
                {t("calculateModeExplanation")}
              </p>
            </div>
          </div>

          {/* Input Fields Guide */}
          <div style={{ marginBottom: "24px" }}>
            <h3
              style={{ ...getStyles(theme).subTitle, color: "var(--primary)" }}
            >
              {t("inputFieldsGuide")}
            </h3>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "12px",
                marginTop: "12px",
              }}
            >
              <div>
                <h4>📏 {t("innerDiameterTitle")}</h4>
                <p style={getStyles(theme).text}>
                  {t("innerDiameterExplanation")}
                </p>
              </div>

              <div>
                <h4>🔧 {t("legLengthTitle")}</h4>
                <p style={getStyles(theme).text}>{t("legLengthExplanation")}</p>
              </div>
            </div>
          </div>

          {/* Advanced Info Guide */}
          <div style={{ marginBottom: "24px" }}>
            <h3
              style={{ ...getStyles(theme).subTitle, color: "var(--primary)" }}
            >
              {t("advancedExplained")}
            </h3>
            <div
              style={{
                backgroundColor: "var(--sectionBackground)",
                padding: "16px",
                borderRadius: "8px",
              }}
            >
              <h4>⚡ {t("powerCalcsTitle")}</h4>
              <p style={getStyles(theme).text}>{t("powerCalcsExplanation")}</p>

              <h4 style={{ marginTop: "16px" }}>
                🌡️ {t("thermalFactorsTitle")}
              </h4>
              <p style={getStyles(theme).text}>
                {t("thermalFactorsExplanation")}
              </p>
            </div>
          </div>

          {/* Results Guide */}
          <div style={{ marginBottom: "24px" }}>
            <h3
              style={{ ...getStyles(theme).subTitle, color: "var(--primary)" }}
            >
              {t("resultsExplained")}
            </h3>
            <div
              style={{
                display: "grid",
                gap: "16px",
                gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
              }}
            >
              <div
                style={{
                  padding: "16px",
                  backgroundColor: "var(--sectionBackground)",
                  borderRadius: "8px",
                }}
              >
                <h4>📊 {t("basicResultsTitle")}</h4>
                <ul style={{ listStyle: "none", padding: 0 }}>
                  {t("basicResultsList")
                    .split("\n")
                    .map((item, index) => (
                      <li key={index}>• {item}</li>
                    ))}
                </ul>
              </div>

              <div
                style={{
                  padding: "16px",
                  backgroundColor: "var(--sectionBackground)",
                  borderRadius: "8px",
                }}
              >
                <h4>⚠️ {t("warningsTitle")}</h4>
                <ul style={{ listStyle: "none", padding: 0 }}>
                  {t("warningsList")
                    .split("\n")
                    .map((item, index) => (
                      <li key={index}>• {item}</li>
                    ))}
                </ul>
              </div>
            </div>
          </div>

          {/* Practical Tips */}
          <div>
            <h3
              style={{ ...getStyles(theme).subTitle, color: "var(--primary)" }}
            >
              {t("practicalTips")}
            </h3>
            <div
              style={{
                backgroundColor: "var(--warning)",
                padding: "16px",
                borderRadius: "8px",
                color: "var(--warningText)",
              }}
            >
              <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                {t("practicalTipsList")
                  .split("\n")
                  .map((item, index) => (
                    <li key={index}>• {item}</li>
                  ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoilCalculator;